module.exports = __webpack_public_path__ + "b412e351c8c9aaa61046a3ba142d634b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/colossal_clashes-768.jpg
// module id = 229
// module chunks = 0